import type { IAgendaBreakdown, IAgendaEventType, IIssuerType, IOrderDirection } from "types/graphqlTypes";

export enum EventsCalendarFilterRange {
  Today = "TODAY",
  InTheWeek = "IN_THE_WEEK",
  InTheMonth = "IN_THE_MONTH",
  InTheLastMonth = "IN_THE_LAST_MONTH",
  InTheNextMonth = "IN_THE_NEXT_MONTH",
  InTheNextNinetyDays = "IN_THE_LAST_NINETYDAYS",
  InTheYear = "IN_THE_YEAR",
  InSelectedPeriod = "IN_SELECTED_PERIOD",
}

export enum EventsCalenderFilterEventType {
  All = "ALL",
  Earnings = "EARNINGS",
  Dividends = "DIVIDENDS",
  StockDividends = "STOCK_DIVIDENDS",
  RightsIssue = "RIGHTS_ISSUE",
  StockSplit = "STOCK_SPLIT",
  SpinOff = "SPIN_OFF",
}

export interface IAgendaFilterState {
  startDate: Date;
  endDate: Date;
  myPositions?: boolean;
  isInSP500?: boolean;
  eventType?: EventsCalenderFilterEventType;
  issuerType: IIssuerType;
  searchQuery?: string;
  selectedFilter?: EventsCalendarFilterRange;
  orderBy?: IOrderDirection;
}

export interface IEventsCalendarProps {
  filterState: IAgendaFilterState;
  setFilterState: (nextState: IAgendaFilterState) => void;
  filterByEventTypes?: IAgendaEventType[];
  isRenderInsidePortfolio?: boolean;
}

export interface IRightSideFiltersProps {
  filterState: IAgendaFilterState;
  setFilterState: (nextState: IAgendaFilterState) => void;
  startDate: Date;
  endDate: Date;
  onChange: (range: { startDate: Date; endDate: Date }) => void;
  breakdown?: IAgendaBreakdown;
  isRenderInsidePortfolio?: boolean;
  totalEvents: number;
}
